import { render, staticRenderFns } from "./modelScene.vue?vue&type=template&id=1727e2e3&scoped=true&"
import script from "./modelScene.vue?vue&type=script&lang=js&"
export * from "./modelScene.vue?vue&type=script&lang=js&"
import style0 from "./modelScene.vue?vue&type=style&index=0&id=1727e2e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1727e2e3",
  null
  
)

export default component.exports